module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(7).d84b3bdc.png";